'use client';

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SupplierRegisterPage } from '@/features/suppliers';
import i18n from '@/lib/i18n';

const supplierRegisterSearchSchema = z.object({
  search: z.string().optional(),
  tier: z.string().optional(),
  riskTier: z.string().optional(),
  status: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/suppliers/register')({
  validateSearch: supplierRegisterSearchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.supplierRegister'),
  }),
  component: SuppliersRegisterRoute,
});

function SuppliersRegisterRoute() {
  const search = Route.useSearch();
  return <SupplierRegisterPage search={search as Record<string, unknown>} />;
}
